import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  get: {
    id: 'studio.qxLJfs',
    defaultMessage: 'Get a single {resourceName} resource',
  },
  query: {
    id: 'studio.+fopx3',
    defaultMessage: 'Get all {resourceName} resources',
  },
  create: {
    id: 'studio.eTyQpc',
    defaultMessage: 'Create a new {resourceName} resource',
  },
  delete: {
    id: 'studio.gwT1uG',
    defaultMessage: 'Delete an existing {resourceName} resource',
  },
  $count: {
    id: 'studio.0hZcSE',
    defaultMessage: 'Count {resourceName} resources',
  },
  update: {
    id: 'studio.XAw0Lo',
    defaultMessage: 'Update an existing {resourceName} resource',
  },
  role: {
    id: 'studio.QCmXtC',
    defaultMessage: 'Role: {role}',
  },
  guest: {
    id: 'studio.zF7Cth',
    defaultMessage: 'Guest',
  },
});
